"use client";

import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import { useEffect, useRef, useState } from "react";

const MAPBOX_TOKEN = process.env.NEXT_PUBLIC_MAPBOX_TOKEN;
const MAP_DEFAULT_ZOOM = 14;
const MAP_MIN_ZOOM = 12;
const MAP_MAX_ZOOM = 15;
const MAPBOX_ZOOM_IN_ICON_URL = `data:image/svg+xml,${encodeURIComponent(`
<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_155_931)">
<rect x="2" y="1" width="32" height="32" rx="16" fill="white"/>
<rect x="2.5" y="1.5" width="31" height="31" rx="15.5" stroke="#D9F5FF"/>
<path d="M22.375 16.1666C22.375 19.0431 20.0432 21.3749 17.1667 21.3749C14.2902 21.3749 11.9584 19.0431 11.9584 16.1666C11.9584 13.2901 14.2902 10.9583 17.1667 10.9583C20.0432 10.9583 22.375 13.2901 22.375 16.1666Z" stroke="#144154" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.9166 19.9167L24.0416 23.0417" stroke="#144154" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.1666 14.2917V18.0417" stroke="#144154" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.0416 16.1667L15.2916 16.1667" stroke="#144154" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_155_931" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.121569 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.08 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_155_931"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_155_931" result="shape"/>
</filter>
</defs>
</svg>
`)}`;
const MAPBOX_ZOOM_OUT_ICON_URL = `data:image/svg+xml,${encodeURIComponent(`
<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_155_925)">
<rect x="2" y="1" width="32" height="32" rx="16" fill="white"/>
<rect x="2.5" y="1.5" width="31" height="31" rx="15.5" stroke="#D9F5FF"/>
<path d="M22.375 16.1666C22.375 19.0431 20.0432 21.3749 17.1667 21.3749C14.2902 21.3749 11.9584 19.0431 11.9584 16.1666C11.9584 13.2901 14.2902 10.9583 17.1667 10.9583C20.0432 10.9583 22.375 13.2901 22.375 16.1666Z" stroke="#144154" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.9166 19.9167L24.0416 23.0417" stroke="#144154" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.0416 16.1667L15.2916 16.1667" stroke="#144154" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_155_925" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.121569 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.08 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_155_925"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_155_925" result="shape"/>
</filter>
</defs>
</svg>
`)}`;
const MAPBOX_FULLSCREEN_ENTER_ICON_URL = `data:image/svg+xml,${encodeURIComponent(`
<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_161_2664)">
<rect x="2" y="1" width="50" height="50" rx="25" fill="white"/>
<rect x="3" y="2" width="48" height="48" rx="24" stroke="#D9F5FF" stroke-width="2"/>
<path d="M16.729 29.8959V33.4376C16.729 35.0024 17.9975 36.2709 19.5623 36.2709H23.104M37.2707 29.8959V33.4376C37.2707 35.0024 36.0021 36.2709 34.4373 36.2709H30.8957M37.2707 22.1042V18.5626C37.2707 16.9978 36.0021 15.7292 34.4373 15.7292H30.8957M16.729 22.1042V18.5626C16.729 16.9978 17.9975 15.7292 19.5623 15.7292H23.104" stroke="#144154" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_161_2664" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.121569 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.08 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_161_2664"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_161_2664" result="shape"/>
</filter>
</defs>
</svg>
`)}`;
const MAPBOX_FULLSCREEN_EXIT_ICON_URL = `data:image/svg+xml,${encodeURIComponent(`
 <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_161_2671)">
<rect x="2" y="1" width="50" height="50" rx="25" fill="white"/>
<rect x="3" y="2" width="48" height="48" rx="24" stroke="#D9F5FF" stroke-width="2"/>
<path d="M36.3186 33.9603C36.4078 34.0494 36.4785 34.1553 36.5268 34.2719C36.5751 34.3884 36.5999 34.5133 36.5999 34.6394C36.5999 34.7656 36.5751 34.8905 36.5268 35.007C36.4785 35.1235 36.4078 35.2294 36.3186 35.3186C36.2294 35.4078 36.1235 35.4785 36.007 35.5268C35.8905 35.5751 35.7656 35.5999 35.6394 35.5999C35.5133 35.5999 35.3884 35.5751 35.2719 35.5268C35.1553 35.4785 35.0494 35.4078 34.9603 35.3186L26.9999 27.357L19.0395 35.3186C18.8594 35.4987 18.6151 35.5999 18.3604 35.5999C18.1056 35.5999 17.8613 35.4987 17.6812 35.3186C17.5011 35.1385 17.3999 34.8942 17.3999 34.6394C17.3999 34.3847 17.5011 34.1404 17.6812 33.9603L25.6428 25.9999L17.6812 18.0395C17.5011 17.8594 17.3999 17.6151 17.3999 17.3604C17.3999 17.1056 17.5011 16.8613 17.6812 16.6812C17.8613 16.5011 18.1056 16.3999 18.3604 16.3999C18.6151 16.3999 18.8594 16.5011 19.0395 16.6812L26.9999 24.6428L34.9603 16.6812C35.1404 16.5011 35.3847 16.3999 35.6394 16.3999C35.8942 16.3999 36.1385 16.5011 36.3186 16.6812C36.4987 16.8613 36.5999 17.1056 36.5999 17.3604C36.5999 17.6151 36.4987 17.8594 36.3186 18.0395L28.357 25.9999L36.3186 33.9603Z" fill="#144154"/>
</g>
<defs>
<filter id="filter0_d_161_2671" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.121569 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.08 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_161_2671"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_161_2671" result="shape"/>
</filter>
</defs>
</svg>
`)}`;
const MAPBOX_MARKER_SVG = `
  <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_dd_156_2658)">
<g filter="url(#filter1_d_156_2658)">
<path d="M56 27C56 13.1929 44.8071 2 31 2C17.1929 2 6 13.1929 6 27C6 40.8071 17.1929 52 31 52C44.8071 52 56 40.8071 56 27Z" fill="#D96545"/>
</g>
</g>
<path d="M19.3892 21.2212C27.0215 14.4344 32.255 12.7377 33.1818 13.1755C34.1086 13.6135 41.6863 21.7686 41.5772 22.8632C41.4682 23.9579 42.8311 36.9294 41.5772 37.3126C40.3235 37.6957 33.1818 38.8999 32.8547 37.3126C32.5277 35.7253 33.1272 29.5953 32.3096 28.9932C31.6554 28.5117 30.2561 28.5736 29.6382 28.6649C29.711 31.219 29.6492 36.3821 28.8206 36.6011C27.7847 36.8747 18.6806 35.9443 18.517 35.5611C18.3861 35.2546 19.044 25.8735 19.3892 21.2212Z" fill="#FFF3E9"/>
<defs>
<filter id="filter0_dd_156_2658" x="0" y="0" width="62" height="62" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="3"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.121569 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_156_2658"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.121569 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.06 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_156_2658" result="effect2_dropShadow_156_2658"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_156_2658" result="shape"/>
</filter>
<filter id="filter1_d_156_2658" x="4" y="1" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.121569 0 0 0 0 0.160784 0 0 0 0 0.215686 0 0 0 0.08 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_156_2658"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_156_2658" result="shape"/>
</filter>
</defs>
</svg>
`;

const setMapZoomInteractions = (map, isEnabled) => {
  if (!map) {
    return;
  }

  const mode = isEnabled ? "enable" : "disable";
  map.scrollZoom?.[mode]?.();
  map.boxZoom?.[mode]?.();
  map.doubleClickZoom?.[mode]?.();
  map.touchZoomRotate?.[mode]?.();
  map.keyboard?.[mode]?.();
};

/**
 * @typedef {import("@prismicio/client").Content.MapSlice} MapSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<MapSlice>} MapProps
 * @type {import("react").FC<MapProps>}
 */
const Map = ({ slice, context }) => {
  const { type } = context;
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const fullscreenContainerRef = useRef(null);
  const [isNativeFullscreen, setIsNativeFullscreen] = useState(false);
  const [isFallbackFullscreen, setIsFallbackFullscreen] = useState(false);
  const pageData = context?.page?.data;
  const propertyDistrict = typeof pageData?.district === "string" ? pageData.district.trim() : "";
  const propertyCity = typeof pageData?.city === "string" ? pageData.city.trim() : "";

  const latitude = slice.primary.gps_points?.latitude;
  const longitude = slice.primary.gps_points?.longitude;
  const hasCoordinates = typeof latitude === "number" && typeof longitude === "number";
  const isFullscreenActive = isNativeFullscreen || isFallbackFullscreen;

  useEffect(() => {
    if (!mapContainerRef.current || mapRef.current || !MAPBOX_TOKEN || !hasCoordinates) {
      return;
    }

    let activeMap;
    const handleFullscreenChange = () => {
      const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
      setIsNativeFullscreen(Boolean(fullscreenElement));
      if (activeMap) {
        activeMap.resize();
      }
    };

    const initializeMap = async () => {
      const mapboxglModule = await import("mapbox-gl");
      const mapboxgl = mapboxglModule.default;
      const markerElement = document.createElement("div");

      mapboxgl.accessToken = MAPBOX_TOKEN;
      markerElement.innerHTML = MAPBOX_MARKER_SVG;

      activeMap = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/mapbox/streets-v12",
        center: [longitude, latitude],
        zoom: MAP_DEFAULT_ZOOM,
        minZoom: MAP_MIN_ZOOM,
        maxZoom: MAP_MAX_ZOOM,
      });

      new mapboxgl.Marker({
        anchor: "center",
        element: markerElement,
      })
        .setLngLat([longitude, latitude])
        .addTo(activeMap);

      activeMap.addControl(
        new mapboxgl.NavigationControl({
          showCompass: false,
        }),
        "top-right"
      );
      setMapZoomInteractions(activeMap, isFullscreenActive);
      document.addEventListener("fullscreenchange", handleFullscreenChange);
      document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
      mapRef.current = activeMap;
    };

    initializeMap();

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
      if (activeMap) {
        activeMap.remove();
        mapRef.current = null;
      }
    };
  }, [hasCoordinates, latitude, longitude]);

  useEffect(() => {
    if (mapRef.current) {
      setMapZoomInteractions(mapRef.current, isFullscreenActive);
      mapRef.current.resize();
    }

    document.body.style.overflow = isFallbackFullscreen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isFallbackFullscreen, isFullscreenActive]);

  const toggleFullscreen = async () => {
    const element = fullscreenContainerRef.current;
    if (!element) {
      return;
    }

    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
    if (fullscreenElement) {
      if (document.exitFullscreen) {
        await document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      return;
    }

    if (isFallbackFullscreen) {
      setIsFallbackFullscreen(false);
      return;
    }

    if (element.requestFullscreen) {
      await element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else {
      setIsFallbackFullscreen(true);
    }
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`${type === "property_rental" ? "bg-terracota-100" : "bg-bleu-50"}`}
    >
      <div className="framing padding-y padding-x flex flex-col gap-6">
        {isFilled.richText(slice.primary.title) && (
          <PrismicRichText
            field={slice.primary.title}
            components={{
              heading2: ({ children }) => <h2 className="h2 text-bleu-950">{children}</h2>,
              heading3: ({ children }) => <h3 className="h3 text-bleu-950">{children}</h3>,
            }}
          />
        )}

        {hasCoordinates ? (
          <div
            ref={fullscreenContainerRef}
            className={`map-fullscreen-shell relative rounded-sm overflow-hidden border border-bleu-100 bg-white shadow-[inset_0px_0px_2px_0px_rgba(0,0,0,0.30)] ${
              isFallbackFullscreen ? "map-fullscreen-shell--fallback" : ""
            } ${
              !isFullscreenActive ? "map-fullscreen-shell--zoom-disabled" : ""
            }`}
          >
            <button
              type="button"
              className="map-fullscreen-button"
              onClick={toggleFullscreen}
              style={{
                backgroundImage: `url("${isFullscreenActive ? MAPBOX_FULLSCREEN_EXIT_ICON_URL : MAPBOX_FULLSCREEN_ENTER_ICON_URL}")`,
              }}
              aria-label={isFullscreenActive ? "Quitter le plein ecran" : "Passer en plein ecran"}
            />
            <div ref={mapContainerRef} className="map-fullscreen-canvas h-[300px] w-full lg:h-[480px]" />
          </div>
        ) : (
          <div className="rounded-[2rem] border border-dashed border-bleu-200 bg-white px-6 py-10 text-bleu-950">
            La carte ne peut pas s&apos;afficher tant qu&apos;aucun point GPS n&apos;est renseigné.
          </div>
        )}

        {(propertyDistrict || propertyCity) && (
          <div className="body-map text-bleu-950">
            Quartier {propertyDistrict}, {propertyCity}
          </div>
        )}
      </div>
      <style jsx global>{`
        .map-fullscreen-shell .mapboxgl-ctrl-group {
          background: transparent;
          box-shadow: none;
        }

        .map-fullscreen-shell .map-fullscreen-button {
          position: absolute;
          top: 5.25rem;
          right: 0.6rem;
          z-index: 30;
          width: 36px;
          height: 36px;
          border: 0;
          padding: 0;
          background-color: transparent;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 36px 36px;
          cursor: pointer;
        }

        .map-fullscreen-shell .mapboxgl-ctrl-group button.mapboxgl-ctrl-zoom-in {
          width: 36px;
          height: 36px;
          padding: 0;
          background: transparent;
        }

        .map-fullscreen-shell .mapboxgl-ctrl-group button.mapboxgl-ctrl-zoom-in .mapboxgl-ctrl-icon {
          width: 36px;
          height: 36px;
          background-image: url("${MAPBOX_ZOOM_IN_ICON_URL}");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 36px 36px;
        }

        .map-fullscreen-shell .mapboxgl-ctrl-group button.mapboxgl-ctrl-zoom-out {
          width: 36px;
          height: 36px;
          padding: 0;
          background: transparent;
        }

        .map-fullscreen-shell .mapboxgl-ctrl-group button.mapboxgl-ctrl-zoom-out .mapboxgl-ctrl-icon {
          width: 36px;
          height: 36px;
          background-image: url("${MAPBOX_ZOOM_OUT_ICON_URL}");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 36px 36px;
        }

        .map-fullscreen-shell.map-fullscreen-shell--zoom-disabled
          .mapboxgl-ctrl-group
          button.mapboxgl-ctrl-zoom-in,
        .map-fullscreen-shell.map-fullscreen-shell--zoom-disabled
          .mapboxgl-ctrl-group
          button.mapboxgl-ctrl-zoom-out {
          pointer-events: none;
          cursor: default;
          opacity: 0.4;
        }

        .map-fullscreen-shell:fullscreen,
        .map-fullscreen-shell:-webkit-full-screen {
          width: 100vw;
          height: 100vh;
          max-width: none;
          border-radius: 0;
        }

        .map-fullscreen-shell.map-fullscreen-shell--fallback {
          position: fixed;
          inset: 0;
          z-index: 9999;
          width: 100vw;
          height: 100vh;
          max-width: none;
          border-radius: 0;
        }

        .map-fullscreen-shell:fullscreen .map-fullscreen-canvas,
        .map-fullscreen-shell:-webkit-full-screen .map-fullscreen-canvas,
        .map-fullscreen-shell.map-fullscreen-shell--fallback .map-fullscreen-canvas {
          width: 100%;
          height: 100%;
        }
      `}</style>
    </section>
  );
};

export default Map;
